import { Card, Container, Grid, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { withStyles } from '@mui/styles';
import { useForm } from 'react-hook-form';
import { getQuickAccess } from 'src/services/projectDetailService';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const ProjectQuickAccess = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });
  var initalList: any[] = [];
  const [employees, setEmployees] = useState(initalList);

  let initialProjectFilterValues = {
    designation: null,
    trackCode: null,
    year: null,
    week: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });

  const filteredEmployees = applyFilters(employees, filters);

  const paginatedEmployees = applyPagination(filteredEmployees, page, limit);

  const getEmployeeData = () => {
    getQuickAccess().then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const CustomTableRow = withStyles({
    root: {
      backgroundColor: '#E6E9FF !important',
      height: '3rem'
    }
  })(Card);

  const CustomTableColumn = withStyles({
    root: {
      height: '3rem'
    }
  })(Card);

  // custom typography with different text and cursor pointer
  const PrimaryTextTypography = withStyles({
    root: {
      color: '#0096FF',
      cursor: 'pointer'
    }
  })(Typography);

  const [expand, setExpand] = useState(false);
  const [expandedCode, setExpandedCode] = useState('');

  const expandTable = (code: string) => {
    setExpandedCode(code);
    setExpand(!expand);
  };

  const getObjectEntries = (obj) => {
    const objectsArray = [];
    for (const [key, value] of Object.entries(obj)) {
      objectsArray.push(
        <Card
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '1rem'
          }}
        >
          <Typography style={{ fontSize: '11px', width: '10rem' }}></Typography>
          <PrimaryTextTypography
            onClick={() => navigate(`/dashboard/quick-access-table/${key}`)}
            style={{ fontSize: '11px', width: '10rem' }}
          >
            {key}
          </PrimaryTextTypography>
          <Typography
            style={{
              fontSize: '11px',
              paddingLeft: '0.25rem',
              paddingRight: '0.25rem',
              background: 'rgba(195, 222, 211, 0.5)',
              borderRadius: '4px',
              color: `${value === 'In Progress' ? '#00B26A' : '#0069E4'}`
            }}
          >
            {value}
          </Typography>
        </Card>
      );
    }
    return objectsArray;
  };

  return (
    <>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Project Quick Access
            </Typography>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <CustomTableRow
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '1rem'
          }}
        >
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '10rem'
            }}
          >
            {'Account Name'}
          </Typography>
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '10rem'
            }}
          >
            {'Account Code'}
          </Typography>
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '10rem'
            }}
          >
            {'Projects'}
          </Typography>
        </CustomTableRow>
        {paginatedEmployees &&
          paginatedEmployees.length > 0 &&
          paginatedEmployees.map((stat) => (
            <Grid key={stat.accountCode}>
              <CustomTableColumn
                style={{
                  marginTop: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1rem',
                  boxShadow: `${
                    expand &&
                    expandedCode === stat.accountCode &&
                    'rgba(0, 0, 0, 0.15) 0px 3px 0px 0px'
                  }`
                }}
              >
                <Typography style={{ fontSize: '11px', width: '10rem' }}>
                  {stat.accountName}
                </Typography>
                <Typography style={{ fontSize: '11px', width: '10rem' }}>
                  {stat.accountCode}
                </Typography>
                <Typography style={{ fontSize: '11px', width: '10rem' }}>
                  {stat.projectCount}
                </Typography>
                <ExpandMoreIcon
                  onClick={() => expandTable(stat.accountCode)}
                  style={{
                    fontSize: '27px',
                    marginLeft: 'auto',
                    cursor: 'pointer'
                  }}
                />
              </CustomTableColumn>
              {expand && expandedCode === stat.accountCode && (
                <Fragment>
                  <Card
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '1rem',
                      background: 'rgba(186, 206, 229, 0.2)'
                    }}
                  >
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    ></Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Project Name'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Project Status'}
                    </Typography>
                  </Card>
                  {getObjectEntries(stat.projects)}
                </Fragment>
              )}
            </Grid>
          ))}
      </Container>
    </>
  );
};

export default ProjectQuickAccess;
